import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings, fontFamilyHeading, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { lab } from "color";
import { css } from "styled-components";

const calcInitial = "calc(((100vw - 100%) / 2) * -1)";
const calcEnd = "100%";

export const secondaryNavigationStyles = {
    wrapper: css`
        background-color: ${getColor(colorStrings.commonGlobalWhite)};
        padding-right: 0;
        padding-left: 0;
        z-index: 3;
        position: relative;
        font-family: ${fontFamilyHeading};
        font-weight: 700;

        ${mediaQueriesBP.minMD} {
            &::before,
            &::after {
                content: "";
                position: absolute;
                height: 1px;
                z-index: 0;
                bottom: -1px;
            }

            &::before {
                left: ${calcInitial};
                right: ${calcEnd};
            }

            &::after {
                left: ${calcEnd};
                right: ${calcInitial};
            }
        }
    `,
    signInLink: css`
        z-index: 1;
    `,

    languageLink: css`
        background-color: ${getColor(colorStrings.primaryMain)};
        display: none !important;
    `,
};
